import React, { FunctionComponent } from 'react';

import { Payment } from '../../requests/caipirinha-api/interfaces/order.interface';
import { noCardsForm, PaymentForm } from './resources';

interface Props {
  payments: Payment[];
}

const SelectedCard: FunctionComponent<Props> = ({ payments }) => (
  <>
    {payments.map(payment => {
      const filtered = noCardsForm.find(
        (f: PaymentForm) => f.id === String(payment.id),
      );
      return (
        <div key={payment.id} className="details" data-cy='payment-method'>
          <p>{filtered ? filtered.type : 'Cartão de Crédito'}</p>
          <strong>{filtered ? '' : payment.description}</strong>
        </div>
      );
    })}
  </>
);

export default SelectedCard;
